module.exports = " <li class=\"list-group-item {{card.suit}}\" @click=moveCard(card) _v-13bc244e=\"\"> {{card.face}} {{card.suit}} </li> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-13bc244e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card.vue
 ** module id = 12
 ** module chunks = 1
 **/